import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 3 }

import KoreBadge from 'components/device/KoreBadge.vue';
import TwilioBadge from 'components/device/TwilioBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimSourceBadge',
  props: {
    scale: null,
    source: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.source === 'kore')
    ? (_openBlock(), _createBlock(KoreBadge, {
        key: 0,
        scale: __props.scale
      }, null, 8, ["scale"]))
    : (__props.source === 'twilio')
      ? (_openBlock(), _createBlock(TwilioBadge, {
          key: 1,
          scale: __props.scale
        }, null, 8, ["scale"]))
      : (__props.source)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(__props.source) + ")", 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "(unknown source)"))
}
}

})